import React from 'react';
import { Nav as RNav, Navbar, NavItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import styled from 'styled-components';
import banner from '../../public/banner-4.jpg';

const Nav = styled(RNav)`
  margin: auto;
  float: none;
`;

const BannerDiv = styled.div`
  background: white;
  width: 100%;
  display: flow;
  text-align: center;
`;

const BannerText = styled.h1`
  font-family: 'Special Elite', sans-serif;
  font-size: 50px;
  margin: 50px 0px;
  text-align: center;
  color: white;
`;

const BannerImg = styled.img`
  width: 100%;
  min-height: 100%;
  overfow: hidden;
`;

const NoRefreshNavItem = props => (
  <LinkContainer to={props.to} exact>
    <NavItem>
      {props.title}
    </NavItem>
  </LinkContainer>
);

const Navigation = props => (
  <BannerDiv>
    <img className="banner-img" src={banner} />
    <Navbar className="center">
      <Nav>
        <NoRefreshNavItem to='/' title='Home' />
        <NoRefreshNavItem to='/casetemplate' title='Case Template' />
        <NoRefreshNavItem to='/teachingnotes' title='Teaching Notes' />
        <NoRefreshNavItem to='/checkfigures' title='Excel Check Figures' />
        <NoRefreshNavItem to='/legal' title='Legal' />
        <NoRefreshNavItem to='/about' title='About' />
      </Nav>
    </Navbar>
  </BannerDiv>
);

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation.js